import React from 'react';
import { CheckCircle2, Loader2, XCircle, Wrench } from 'lucide-react';
import type { RoundEvent } from './types';

const STATUS_ICON = {
  running: <Loader2 className="h-3 w-3 animate-spin text-violet-600" />,
  success: <CheckCircle2 className="h-3 w-3 text-emerald-600" />,
  error:   <XCircle className="h-3 w-3 text-red-600" />,
};

export const RoundTimeline: React.FC<{ rounds: RoundEvent[] }> = ({ rounds }) => {
  if (rounds.length === 0) {
    return (
      <div className="text-xs text-muted-foreground px-3 py-4 text-center">
        Nessuna attività ancora
      </div>
    );
  }
  return (
    <div className="space-y-2 px-2">
      {rounds.map(r => (
        <div key={r.id} className="rounded-md border border-border bg-card p-2">
          <div className="flex items-center justify-between mb-1">
            <span className="text-[11px] font-semibold text-foreground">Round {r.round}</span>
            {r.completedAt
              ? <CheckCircle2 className="h-3 w-3 text-emerald-500" />
              : <Loader2 className="h-3 w-3 animate-spin text-violet-500" />}
          </div>
          {r.toolCalls.length > 0 && (
            <ul className="space-y-1">
              {r.toolCalls.map((tc, i) => (
                <li key={i} className="flex items-center gap-1.5 text-[11px] text-muted-foreground">
                  <Wrench className="h-3 w-3 text-muted-foreground" />
                  <span className="truncate flex-1">{tc.name}</span>
                  {STATUS_ICON[tc.status]}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};
